
	/**
	 * @description
	 *  Modelo del estado de un ítem en un pedido.
	 *
	 * @see gigot-backend/Models/Orders/Order.cs
	 */

export enum OrderItemStatus {

	Draft = "Draft",
	Finished = "Finished",
	PreviousCycle = "PreviousCycle",
	NoStock = "NoStock",
	Missing = "Missing",
	Delivered = "Delivered"
}
